import { FC } from 'react'
import { AccountLayout } from '../components/layout/AccountLayout'
import { LeaseDetailContent } from '../components/management/leases/LeaseDetailContent'

export const LeaseDetailPage: FC = () => (
  <AccountLayout>
    <LeaseDetailContent />
  </AccountLayout>
)

export default LeaseDetailPage
